<template>
  <div class="readouts">
    <p class="speed">
      {{
        unit === 'mi'
          ? Math.round(readout.speed * 0.621371) || 0
          : readout.speed
      }}
      <small>{{ units[unit].speed }}</small>
    </p>
    <p class="elevation">
      {{
        unit === 'mi'
          ? Math.round(readout.elevation * 3.2808399) || 0
          : readout.elevation
      }}
      <small>{{ units[unit].elevation }} </small>
    </p>
    <p class="distance">
      {{
        readout.distance &&
          (
            (readout.distance / 1000) *
            (unit === 'mi' ? 0.621371 : 1)
          ).toLocaleString(undefined, {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
          })
      }}
      {{ units[unit].distance }}
    </p>
  </div>
</template>

<style lang="scss">
.readouts {
  display: flex;

  p {
    flex-grow: 1;
    padding: 0 10px;
    margin: 0;

    &.speed,
    &.elevation {
      color: #19bfff;
      line-height: 40px;
      font-size: 32px;
    }

    &.elevation {
      color: #57e607;
      text-align: center;
    }

    &.distance {
      text-align: right;
      font-weight: bold;
      font-size: 12px;
      line-height: 12px;
      padding-top: 20px;
    }

    small {
      font-size: 0.4em;
    }
  }
}
</style>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  data() {
    return {
      units: {
        km: { speed: 'KM/H', elevation: 'M', distance: 'km' },
        mi: { speed: 'MPH', elevation: 'FT', distance: 'mi' }
      }
    }
  },

  computed: {
    ...mapState({
      unit: state => state.unit
    }),
    ...mapGetters({
      readout: 'currentReadout'
    })
  }
}
</script>




// WEBPACK FOOTER //
// Readouts.vue?006dba27